import PropTypes from 'prop-types';
import React from 'react';

const Tip = ({ title, subtitle, action }) => {
  return (
    <div className="tip-notification">
      <h2>{title}</h2>
      <p dangerouslySetInnerHTML={{ __html: subtitle }} />
      {action}
    </div>
  );
};

Tip.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  action: PropTypes.object,
};

export default Tip;
